declare global {
  interface Window {
    __RUNTIME_CONFIG__?: {
      API_URL?: string,
      CABLE_URL?: string,
    },
  }
}

// eslint-disable-next-line no-underscore-dangle
const runtimeConfig = window.__RUNTIME_CONFIG__ || {}

export const API_URL = runtimeConfig.API_URL || process.env.API_URL || ''
export const CABLE_URL = runtimeConfig.CABLE_URL || process.env.CABLE_URL || ''
